import React, { Component } from "react";
import ReactTable from "react-table";
import { Configurations } from "../../Utils/Configurations";
import moment from 'moment';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import CileSpdlOrders from "../../Components/Cile-Spdl-Orders/Cile-Spdl-Orders";
import update from 'immutability-helper';
import InputMask from 'react-input-mask';
import './Cile-Shipping.scss';
import axios from "axios";
import ErrorModal from "../../Components/ErrorModal/ErrorModal";

class CileShipping extends Component {
    constructor(props) {
        super(props);

        this.carregarRemessas = this.carregarRemessas.bind(this);
        this.statusCileShipping = this.statusCileShipping.bind(this);
        this.toggleModalPedidosSPDL = this.toggleModalPedidosSPDL.bind(this);
        this.excluirRemessa = this.excluirRemessa.bind(this);
        this.toggleModalExcluirRemessa = this.toggleModalExcluirRemessa.bind(this);
        this.enviarRemessa = this.enviarRemessa.bind(this);
        this.criarNovaRemessa = this.criarNovaRemessa.bind(this);
        this.toggleModalNovaRemessa = this.toggleModalNovaRemessa.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.validacaoDataColeta = this.validacaoDataColeta.bind(this);


        this.Configurations = new Configurations();

        this.state = {
            remessas: [],
            modalPedidosSPDL: false,
            isLoadingEnviarRemessa: false,
            isLoadingExcluirRemessa: false,
            hasError: false,
            errorMessage: '',
            loadingRemessas: false,
        }

        this.columns = [
            {
                Header: "#",
                accessor: "idRemessa",
                width: 50,
                className: "text-center pointer"
            },
            {
                Header: "Data de coleta",
                accessor: "dtColeta",
                width: 140,
                className: "text-center pointer",
                Cell: row => (<span>{row.value !== undefined && row.value !== null ? moment(row.value).format('DD/MM/YY') : '-'}</span>)

            },
            {
                Header: "SPDL",
                accessor: "qtdSPDL",
                width: 90,
                className: "text-center pointer"
            },
            {
                Header: "Melhor envio",
                accessor: "qtdMelhorEnvio",
                width: 90,
                className: "text-center point"
            },
            {
                Header: "Status",
                accessor: "statusRemessa",
                width: 120,
                className: "text-center pointer",
                Cell: row => !!row.value ? <span className={`badge badge-cile badge-${this.statusCileShipping(row.original.idStatusRemessa)}`}>{row.value}</span> : <span></span>
            },
            {
                Header: "",
                accessor: "idRemessa",
                width: 150,
                className: "text-center pointer",
                Cell: row => <button onClick={() => this.props.history.push(`/cile/remessas/detalhes/${row.value}`)} className="btn btn-outline-success" >ver detalhes</button>
            },
            {
                Header: "",
                className: "text-center pointer",
                Cell: row => {
                    const enviada = row.original.idStatusRemessa === 2;
                    const loading = row.original.isLoadingEnviarRemessa;
                    const qtdMelhorEnvio = row.original.qtdMelhorEnvio;
                    const qtdSPDL = row.original.qtdSPDL
                    return (
                        !enviada && (
                            <React.Fragment>
                                {loading ? (
                                    <div className="spinner-border spinner-border text-primary align-items-center" role="status" />
                                ) : (
                                    <React.Fragment>
                                        {(qtdMelhorEnvio !== 0 || qtdSPDL !== 0) && (
                                            <button onClick={() => this.enviarRemessa(row.original.idRemessa)} className="btn btn-outline-info">enviar remessa</button>
                                        )}
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        )
                    )
                }
            },
            {
                Header: "",
                className: "text-center pointer",
                Cell: row => {
                    const enviada = row.original.idStatusRemessa === 2;
                    return (
                        !enviada && (
                            <i onClick={() => this.toggleModalExcluirRemessa(row.original.idRemessa)} className={`far fa-trash-alt text-danger ml-2 cursor-pointer`}></i>
                        )

                    )

                }
            }
        ]
    }

    carregarRemessas(o) {
        this.setState({ loadingRemessas: true })
        const _params = [];

        if (!o.pageSize) {
            o.pageSize = 20;
            _params.push(`qtdItens=${o.pageSize}`);
        } else if (!(o.page + 1)) {
            o.page = 1;
            _params.push(`pagina=${o.page}`);
            o.sorted = []
            _params.push(`ordenacao=${o.sorted.map(item => item.id).join(',')}`);
        } else {
            _params.push(`qtdItens=${o.pageSize}`);
            _params.push(`pagina=${o.page + 1}`);
        }

        const _carriers = axios.get(this.Configurations.apiBasePath + `/logistica-cile/remessas/lista?${_params.join('&')}`);
        _carriers.then(response => {
            this.setState({
                remessas: response.data.listaRemessas,
                paginas: response.data.paginacao.totalPaginas,
                paginaAtual: response.data.paginacao.paginaAtual,
            })
        }).catch(this.handleError).finally(() => this.setState({ loadingRemessas: false }))
    }

    criarNovaRemessa() {
        this.setState({ isLoadingNovaRemessa: true })

        const arrayDtColeta = this.state.dataColeta.split("/"),
            dia = arrayDtColeta[0],
            mes = arrayDtColeta[1],
            ano = arrayDtColeta[2];

        const dtFormat = `${ano}-${mes}-${dia}`;

        const _body = {
            dtColeta: dtFormat
        };
        axios.post(this.Configurations.apiBasePath + `/logistica-cile/remessas/nova-remessa`, _body).then(response => {
            this.setState({
                dataColeta: ''
            })
            this.toggleModalNovaRemessa();
            this.carregarRemessas({});
        }).catch(this.handleError).finally(() => this.setState({ isLoadingNovaRemessa: false }))
    }


    statusCileShipping(id) {
        switch (id) {
            case 2:
                return "success";
            case 1:
                return "warning";
            default:
                return "warning";
        }
    }

    toggleModalPedidosSPDL(id) {
        this.setState({
            idRemessaDetalhes: !!id ? id : null
        }, () => {
            this.setState({
                modalPedidosSPDL: !this.state.modalPedidosSPDL
            })
        })
    }

    enviarRemessa(id) {
        const _index = this.state.remessas.findIndex(item => item.idRemessa === id);
        this.setState({ remessas: update(this.state.remessas, { [_index]: { isLoadingEnviarRemessa: { $set: true } } }) })
        axios.post(this.Configurations.apiBasePath + `/logistica-cile/remessas/enviar-arquivo-remessa/${id}`).then(response => {
            this.carregarRemessas({});
        }).catch(this.handleError).finally(() => this.setState({ remessas: update(this.state.remessas, { [_index]: { isLoadingEnviarRemessa: { $set: false } } }) }))
    }

    excluirRemessa() {
        this.setState({ isLoadingExcluirRemessa: true })
        axios.delete(this.Configurations.apiBasePath + `/logistica-cile/remessas/excluir/${this.state.idRemessaExcluida}`).then(response => {
            this.carregarRemessas({});
            this.toggleModalExcluirRemessa();
            this.setState({
                idRemessaExcluida: null,
            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingExcluirRemessa: false }))
    }

    toggleModalExcluirRemessa(id) {
        this.setState({
            idRemessaExcluida: id,
            isOpenModalExcluirRemessa: !this.state.isOpenModalExcluirRemessa,
        })
    }

    toggleModalNovaRemessa() {
        this.setState({
            modalNovaRemessa: !this.state.modalNovaRemessa,
            flagSucessoEnvioRemessa: false
        })
    }

    handleInput(e) {
        e.preventDefault();
        const _name = e.target.name
        this.setState({ [_name]: e.target.value })
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }


    validacaoDataColeta(dtColeta) {
        // First check for the pattern
        if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dtColeta))
            return false;

        // Parse the date parts to integers
        var parts = dtColeta.split("/");
        var day = parseInt(parts[0], 10);
        var month = parseInt(parts[1], 10);
        var year = parseInt(parts[2], 10);

        // Check the ranges of month and year
        if (year < 1000 || year > 3000 || month === 0 || month > 12)
            return false;

        var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        // Adjust for leap years
        if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0))
            monthLength[1] = 29;

        // Check the range of the day
        return day > 0 && day <= monthLength[month - 1];
    }

    render() {
        return (
            <div className="cile-remessas">
                <div className="row">
                    <div className="col-8 text-left">
                        <h2 className="title-1">Lista de remessas - CILE</h2>
                    </div>
                    <div className="col-4 text-right">
                        <button className="btn btn-outline-success" onClick={this.toggleModalNovaRemessa}>Nova remessa</button>
                    </div>
                    <div className="col-12 py-2">
                        <div className="card tabela-lista-remessas">
                            <div className="card-body p-0">
                                <ReactTable
                                    data={this.state.remessas}
                                    columns={this.columns}
                                    onFetchData={this.carregarRemessas}
                                    defaultPageSize={50}
                                    pages={this.state.paginas}
                                    manual
                                    loading={this.state.loadingRemessas}
                                    className="-striped -highlight"
                                    headerClassName="ebs-table-header"
                                    previousText='Anterior'
                                    nextText='Próximo'
                                    loadingText='Carregando...'
                                    noDataText='Nenhuma remessa encontrada.'
                                    pageText='Página'
                                    ofText='de'
                                    rowsText='linhas'
                                    pageSizeOptions={[5, 10, 25, 50, 100, 200, 300]}
                                />

                            </div>

                        </div>
                    </div>
                </div>

                <Modal className="modal-pedidos-spdl" size="lg" isOpen={this.state.modalPedidosSPDL} toggle={this.toggleModalPedidosSPDL}>
                    <ModalHeader toggle={this.toggleModalPedidosSPDL}></ModalHeader>
                    <ModalBody>
                        <CileSpdlOrders
                            idRemessaDetalhes={this.state.idRemessaDetalhes}
                            carregarListaRemessas={this.carregarRemessas}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.isOpenModalExcluirRemessa} toggle={this.toggleModalExcluirRemessa}>
                    <ModalHeader toggle={this.toggleModalExcluirRemessa}>Excluir remessa</ModalHeader>
                    <ModalBody>
                        Deseja realmente excluir remessa?
                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingExcluirRemessa ? (
                            <div className="col-6 text-right">
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                        ) : (
                            <Button color="danger" onClick={this.excluirRemessa}>Excluir</Button>
                        )}
                        <Button color="secondary" onClick={this.toggleModalExcluirRemessa}>Cancelar</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modalNovaRemessa} toggle={this.toggleModalNovaRemessa}>
                    <ModalHeader toggle={this.toggleModalNovaRemessa}>Remessa SPDL</ModalHeader>
                    <ModalBody>
                        {this.state.flagSucessoEnvioRemessa ? (
                            <div className='row no-gutters'>
                                <div className='col-12 text-center pt-3'>
                                    <p><i className='text-success'>Arquivo enviado com sucesso!</i></p>
                                </div>
                            </div>
                        ) : (
                            <div className='row no-gutters'>
                                <div className='col-6 py-1 px-2 text-left'>
                                    <label>Data de coleta</label>
                                    <InputMask
                                        type="tel"
                                        className="form-control text-left"
                                        maskChar=""
                                        mask="99/99/9999"
                                        id="dataColeta"
                                        name="dataColeta"
                                        placeholder="DD/MM/AAAA"
                                        value={this.state.dataColeta}
                                        onChange={this.handleInput}
                                        autoComplete="disabled"
                                    />
                                </div>
                            </div>
                        )}
                    </ModalBody>
                    {!this.state.flagSucessoEnvioRemessa && (
                        <ModalFooter>
                            {this.state.isLoadingNovaRemessa ? (
                                <div className="spinner-border text-primary text-center" role="status" />
                            ) : (
                                <React.Fragment>
                                    <Button color="secondary" onClick={this.toggleModalNovaRemessa}>Voltar</Button>
                                    <Button color="success" onClick={this.criarNovaRemessa} disabled={!this.validacaoDataColeta(this.state.dataColeta)}>Criar remessa</Button>
                                </React.Fragment>
                            )}
                        </ModalFooter>
                    )}
                </Modal>
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
            </div>
        )
    }
}

export default CileShipping;